// extracted by mini-css-extract-plugin
export default {"container":"contract-status_container__Njtse","title":"contract-status_title__M-NcB","description":"contract-status_description__uYAvd"};